import { useForm } from "react-hook-form";
import EdTextfield from "../../components/forms/EdTextfield";
import { TERipple } from "tw-elements-react";
import EdocertLogo from "../../assets/edocert-logo.svg";
import ExagonLogo from "../../assets/exagon-logo.svg";
import { Link } from "react-router-dom";
import { useForgotPassword } from "./hooks/useAuth";

interface ForgotPasswordFormInputs {
  email: string;
}

export default function ForgotPasswordPage() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotPasswordFormInputs>({
    mode: "onSubmit",
  });

  const { mutate: forgotPassword } = useForgotPassword();

  const onSubmit = async (data: ForgotPasswordFormInputs) => {
    forgotPassword({ email: data.email });
  };

  return (
    <div className="flex min-h-screen items-start pt-[80px]  justify-center bg-gray-100 w-screen relative">
      <div className="absolute top-0 z-0 w-full h-1/2 bg-red-800"></div>
      <div className="w-full max-w-[658px] max-h-[502px] box-border z-30">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="bg-white shadow-md rounded-lg px-8 md:px-[120px] mx-4 md:mx-0 pb-14 pt-10"
        >
          <div className="flex justify-center mb-8">
            <img src={EdocertLogo} className="w-[260px]" />
          </div>
          <div className="flex flex-col gap-2 mb-5 w-full">
            <span className="text-[#4F4F4F] text-sm font-bold">
              Password dimenticata
            </span>
            <span className="text-[#4F4F4F] text-sm">
              Inserisci la tua email e cliccando sul bottone RESETTA PASSWORD
              rivceverai una email che ti permetterà di ridefinire la tua
              password
            </span>
          </div>

          <div className="mb-4">
            <EdTextfield
              label="Inserisci email"
              type="text"
              id="email"
              placeholder="Inserisci email"
              register={register("email", {
                required: "Campo obbligatorio",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Indirizzo email non valido",
                },
              })}
              error={errors.email && errors.email.message}
            />
          </div>

          <div className="flex flex-col gap-4">
            <TERipple rippleColor="light" className="w-full">
              <button
                type="submit"
                className="w-full rounded bg-red-700 px-6 pb-2.5 pt-3 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out hover:bg-red-800"
              >
                Resetta password
              </button>
            </TERipple>
          </div>

          <div className="flex justify-center items-center mt-5 mb-4 w-full text-center">
            <div className="flex w-full text-sm text-center">
              <Link
                to="/login"
                className="w-full font-medium text-center text-edPrimaryColor-500 hover:text-red-800"
              >
                Effettua il login
              </Link>
            </div>
          </div>
          <div className="flex justify-center">
            <img src={ExagonLogo} className="" />
          </div>
        </form>
      </div>
    </div>
  );
}
